import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import setStyles from "../../setStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    maxWidth: "800px",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 25px",
    },
  },
  h2: {
    color: "#05070B",
    ...setStyles.sofiaProBold,
    fontSize: "36px",
    paddingBottom: "16px",
  },
  p: {
    color: "#404040",
    opacity: 0.8,
    ...setStyles.sofiaProRegular,
    fontSize: "18px",
  },
  legalDisclaimerCard: {
    width: "100%",
    height: "fit-content",
    borderRadius: "10px",
    boxShadow: "1px 1px 5px grey",
    padding: "18px",
    backgroundColor: "rgba(255, 0, 43, 0.2)",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    marginTop: "16px",
    marginBottom: "16px",
  },
}));

const Header = () => {
  const classes = useStyles();
  const legalDisclaimer =
    "The Stratic notepad is designed for general use, not for storing sensitive personal information. Please avoid entering confidential details such as passwords, Social Security numbers, medical data, or payment information. While we take data protection seriously, these notes are not encrypted for sensitive content. We recommend using this feature for high-level client notes only, and at your own discretion.";
  return (
    <>
      <h2 className={classes.h2}>Notepad</h2>
      <p className={classes.p}>
        Stratic has built a network of experienced professionals in various
        industries throughout the country to provide players with the best
        possible assistance for their everyday needs. Here you can manage your
        tasks and some notes.
      </p>
      <div className={classes.legalDisclaimerCard}>
        <p className={classes.p}> {legalDisclaimer}</p>
      </div>
    </>
  );
};

export default Header;
